import { render } from "./PaneListParadigms.vue?vue&type=template&id=13241aa0&scoped=true&ts=true"
import script from "./PaneListParadigms.vue?vue&type=script&lang=ts"
export * from "./PaneListParadigms.vue?vue&type=script&lang=ts"

import "./PaneListParadigms.vue?vue&type=style&index=0&id=13241aa0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13241aa0"]])

export default __exports__